import { createActionsStructure } from 'services/reduxHelpers'

/* ------------- Action Creators ------------- */

export const { blacklistTypes, blacklistActions } = createActionsStructure('blacklist', [
  { name: 'GET_BLACKLIST_BOOKINGS', async: true },
  { name: 'GET_BLACKLIST_PASSENGER_BOOKINGS', async: true },
  { name: 'ADD_BLACKLIST_BOOKING', async: true },
  { name: 'DELETE_BLACKLIST_BOOKING', async: true },
  { name: 'DELETE_BLACKLIST_PASSENGER', async: true },
  { name: 'BLACKLIST_HANDLE_ROUTE_INFO', async: true }
])



// WEBPACK FOOTER //
// ./src/reduxModules/actions/BlacklistActions.js